import { format as formatDateFNS } from 'date-fns';

const DATE_FORMAT = 'MM/dd/yyyy';

export const formatDate = (date, format) =>
  formatDateFNS(date, format || DATE_FORMAT);
export const formatCurrency = value =>
  new Intl.NumberFormat('en-IN').format(value);
export const DEFAULT_DATE_FORMAT = DATE_FORMAT;
